import axios_instance from './liveChatAxiosInst';

async function getComList(state, dispatch) { // console.log('getComList');
    await axios_instance.post(
        process.env.REACT_APP_LIVE_CHAT_API,
        {
            action: "readComList_admin",
            operator_id: state.active_operator_id,
            pseudo: state.pseudo,
        },
    )
    .then((resp) => {
        if (resp.status === 200) { // console.log('getComList => com_list : ', resp.data)
            dispatch({type: 'change_com_list', payload: {com_list: resp.data.comList}})
        } else {
            // console.log('getComList => pas 200')
            dispatch({type: 'change_com_list', payload: {com_list: []}})
        }
    })
    .catch (() => dispatch({type: 'change_com_list', payload: {com_list: []}}));
}

export default getComList;